export default __webpack_public_path__ + "static/media/RhymesAnimalTales_02.dcd91c00.png";